module.exports = __webpack_public_path__ + "static/media/ic_教学体验.fd98ab28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_教学体验.svg
// module id = 407
// module chunks = 0